export default __webpack_public_path__ + "static/media/lbaLogo.d6b30602.svg";